var render = function render(){var _vm=this,_c=_vm._self._c;return _c('generic-view',{attrs:{"entity_name":"language","title":"Languages","headers":_vm.headers,"icon":"mdi-flag"}})
}
var staticRenderFns = []

export { render, staticRenderFns }